import { getThumbnailUrl } from '@avantstay/backoffice-core'

import { mountRouteUrl, ROUTES } from '@routes'

import * as S from './PropertiesDetail.styles'

type PropertiesDetailProps = {
  id: string
  name: string
  thumbnail: string
  region?: string
}

export function PropertiesDetail({
  id,
  name,
  thumbnail,
  region,
}: PropertiesDetailProps): JSX.Element {
  return (
    <S.Container
      data-cy={`omnisearch-property-${name}`}
      to={mountRouteUrl(ROUTES.propertyInfo.path, { id, section: 'basic-info', viewMode: 'read' })}
    >
      {thumbnail ? (
        <S.HouseAvatar
          data-cy={`omnisearch-property-thumbnail-${name}`}
          size="34px"
          src={getThumbnailUrl({ originalSrc: thumbnail })}
        />
      ) : (
        <S.HomePlaceHolderIcon>
          <S.IconPropertyInfoStyled />
        </S.HomePlaceHolderIcon>
      )}

      <S.ContainerGroup data-cy={`omnisearch-property-region-${name}`}>
        <S.Name>{name}</S.Name>
        {region && <S.Region>{region}</S.Region>}
      </S.ContainerGroup>
    </S.Container>
  )
}
